import { render, staticRenderFns } from "./LeaveAttendanceGeneral.vue?vue&type=template&id=6cfba78c"
import script from "./LeaveAttendanceGeneral.vue?vue&type=script&lang=js"
export * from "./LeaveAttendanceGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports